// extracted by mini-css-extract-plugin
export default {"card":"MoreNewCard_card__RL5dn","imagess":"MoreNewCard_imagess__UYLhX","title":"MoreNewCard_title__QLqxE"};